import React from 'react';
// Styles
import styles from './style/drawerContent.module.css';

interface DraweContentProps {
  children: React.ReactNode,
  overflow?: boolean,
}

function DrawerContent({ children, overflow }: DraweContentProps) {
  return (
    <div className={`${styles.main} ${overflow ? styles.main_overflow : ''}`}>
      { children }
    </div>
  );
}

DrawerContent.defaultProps = {
  overflow: false,
}

export default DrawerContent;
